import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cashout-tooltip',
    templateUrl: './cashout-tooltip.component.html',
    styleUrls: ['./cashout-tooltip.component.scss'],
    standalone: true,
})
export class CashoutTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
